import {
  DateField,
  List,
  Table,
  useModal,
  useTable
} from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { definitions } from 'interfaces'
import { DEFAULT_DATE_TIME_FORMAT } from 'utility'

export const UserSubscriptions: React.FC<{ usersSubscription: definitions['users_subscriptions'] }> = ({ usersSubscription }) => {
  const t = useTranslate()

  const { tableProps: postTableProps } = useTable<definitions['users_subscriptions']>({
    resource: 'users_subscriptions',
    metaData: {
      select: 'subscriptions(name), created_at, expired_at'
    },
    permanentFilter: [
      {
        field: 'user_id',
        operator: 'eq',
        value: usersSubscription.user_id
      }
    ],
    initialSorter: [
      {
        field: 'created_at',
        order: 'asc'
      }
    ]
  })

  useModal()

  return (
    <List
      title={`${t('subscriptions.susbscriptions')}`}
      breadcrumb={null}
    >
      <Table {...postTableProps}>
        <Table.Column
          key='created_at'
          dataIndex={['created_at']}
          title={t('subscriptions.created_at')}
          align='center'
          render={(value) => value ? <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/> : null}
          sorter
        />
        <Table.Column
          key='id'
          dataIndex={['expired_at']}
          title={t('subscriptions.expired_at')}
          align='center'
          render={(value) => value ? <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/> : null}
          sorter
        />
      </Table>
    </List>
  )
}
